import React, { Component } from "react";
import { connect } from "react-redux";

import Loader from "./../utils/Loader";

class ProductPreviewImage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			height: 276,
			width: 192
		};

		// const { product } = this.props;
		// if (product.images.length) {
		this.state = {
			// height: this.props.height,
			width: this.props.width
		};
		// }
	}

	render() {
		const { product } = this.props;
		let no_product_img = "";

		// console.log('img render', product)

		// Set no product image
		if (!!this.props.siteInfo.site) {
			no_product_img = this.props.siteInfo.site.no_product_img;
		}

		let img = <Loader height={this.state.height} width={this.state.width} />;

		if (no_product_img !== "" || !product.images.length) {
			// Default no product image
			let src = no_product_img;
			let alt = product.title;

			// Product image available
			if (product.images.length) {
				src = product.images[0].sizes.preview.src;
				alt = product.images[0].alt;
			}

			img = <img width={this.state.width} src={src} alt={alt} />;
		}

		return img;
	}
}

const mapStateToProps = state => {
	return {
		siteInfo: state.siteInfo
	};
};

export default connect(mapStateToProps)(ProductPreviewImage);



// WEBPACK FOOTER //
// ./src/components/product/ProductPreviewImage.js